import { cn } from '../../lib/cn';
import { Card } from '../design-system/Card';
import { Text } from '../design-system/Text';
import { ChevronRight, Car } from 'lucide-react';
import type { Vehicle } from '../../types';

interface VehicleSummaryHeaderProps {
  vehicle: Vehicle;
  chipSlot?: React.ReactNode;
  onClick?: () => void;
}

export function VehicleSummaryHeader({
  vehicle,
  chipSlot,
  onClick,
}: VehicleSummaryHeaderProps) {
  return (
    <Card
      padding="md"
      elevation={0}
      className={cn(
        'mx-4 mt-4 rounded-2xl border-0 bg-white dark:bg-slate-800',
        onClick && 'cursor-pointer active:bg-slate-50 dark:active:bg-slate-700/50'
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-park-50 text-park-600 dark:bg-park-900/30 dark:text-park-400">
            <Car className="h-6 w-6" />
          </div>
          <div className="min-w-0">
            <Text variant="title" className="truncate">{vehicle.number}</Text>
            <Text variant="caption" color="secondary">{vehicle.label}</Text>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          {chipSlot}
          <ChevronRight className="h-5 w-5 text-slate-400" />
        </div>
      </div>
    </Card>
  );
}
